/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import history from '@history';
import _ from '@lodash';
import { setInitialSettings } from 'app/store/abs/settingsSlice';
import { showMessage } from 'app/store/abs/messageSlice';
import settingsConfig from 'app/configs/settingsConfig';
import absWebService from 'app/services/absWebService';

export const setUser = createAsyncThunk('user/setUser', async (user, { dispatch, getState }) => {
	/*
	  You can redirect the logged-in user to a specific route depending on his role
	  */
	if (user.loginRedirectUrl) {
		settingsConfig.loginRedirectUrl = user.loginRedirectUrl; // for example 'apps/academy'
	}

	return user;
});

export const updateUserSettings = createAsyncThunk(
	'user/updateSettings',
	async (settings, { dispatch, getState }) => {
		const { user } = getState();
		const newUser = _.merge({}, user, { data: { settings } });

		dispatch(updateUserData(newUser));

		//   return newUser;
	}
);

export const updateUserShortcuts = createAsyncThunk(
	'user/updateShortucts',
	async (shortcuts, { dispatch, getState }) => {
		const { user } = getState();
		const newUser = {
			...user,
			data: {
				...user.Settings_ABSWeb,
				shortcuts,
			},
		};

		dispatch(updateUserData(newUser));

		return newUser;
	}
);

export const logoutUser = () => async (dispatch, getState) => {
	const { user } = getState();

	if (!user.modules || user.modules.length === 0) {
		// if not logged in
		return null;
	}

	history.push({
		pathname: '/'
	});

	dispatch(setInitialSettings());

	return dispatch(userLoggedOut());
};

export const updateUserData = user => async (dispatch, getState) => {
	if (!user.modules || user.modules.length === 0) {
		// if not logged in
		return;
	}

	// absWebService
	// .updateUserData(user)
	// .then(() => {
	// 	// dispatch(showMessage({ message: 'User data saved with api' }));
	// })
	// .catch(error => {
	// 	dispatch(showMessage({ message: 'Error updating user', variant: 'error' }));
	// });
};

export const checkLogoutOnAction = () => async (dispatch, getState) => {
	const { user } = getState();

	if (user?.LogoutAfterAction === true) {
		await new Promise(r => setTimeout(() => r(), 3000));
		absWebService.logout();
	}
};

const initialState = {
	modules: [], //if modules is empty it means not logged in
	User_Firstname: 'Default',
	User_Name: 'User',
	E_Mail: null,
	Settings_ABSWeb: null
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		userLoggedOut: (state, action) => initialState,
	},
	extraReducers: {
		[updateUserSettings.fulfilled]: (state, action) => action.payload,
		[updateUserShortcuts.fulfilled]: (state, action) => action.payload,
		[setUser.fulfilled]: (state, action) => action.payload,
	},
});

export const { userLoggedOut } = userSlice.actions;

export const selectUser = ({ user }) => user;

export const selectUserShortcuts = ({ user }) => (user.Settings_ABSWeb != null && user.Settings_ABSWeb.shortcuts != null) ? user.Settings_ABSWeb.shortcuts : [];

export default userSlice.reducer;
